import React, { useState, useEffect, useRef } from "react"
import VisibilitySensor from "react-visibility-sensor"
import AppendixItems from "../data/appendix.json"
import IconAppendix from "../images/appendix.inline.svg"
import IconClose from "../images/close.inline.svg"
import IconExternalLink from "../components/svg/icon-external-link"
import FocusLock from "react-focus-lock"

export const Appendix = ({ page }) => {
  const appendixButton = useRef()
  const [active, setActive] = useState(false)

  const toggleOverlay = () => {
    const BODY_LOCK = "util__body-lock"

    if (active) {
      setActive(false)
      document.body.classList.remove(BODY_LOCK)
    } else {
      setActive(true)
      document.body.classList.add(BODY_LOCK)
    }
  }

  const pageData = AppendixItems.find(obj => {
    return obj.page === page
  })

  // Simple listener to close overlay on escape key hit
  function handleKeydown(e) {
    if (e.keyCode === 27 && active) {
      toggleOverlay()
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", handleKeydown)
    return () => {
      document.removeEventListener("keydown", handleKeydown)
    }
  })

  return (
    <>
      <FocusLock
        disabled={active ? false : true}
        shards={[active ? appendixButton : null]}
        returnFocus={true}
        noFocusGuards={true}
      >
        <div
          id="appendix__overlay"
          className="appendix__overlay"
          aria-hidden={active ? "false" : "true"}
          tabIndex="-1"
        >
          <div className="appendix__overlay__content">
            <h3 className="title--secondary title--uppercase">
              Further Reading
            </h3>
            <ul>
              {pageData.items.map((item, index) => {
                return (
                  <li key={index}>
                    <a href={item.href}>
                      <IconExternalLink />
                      <span
                        dangerouslySetInnerHTML={{ __html: item.text }}
                      ></span>
                    </a>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </FocusLock>
      <div className="appendix">
        <div
          className={
            active
              ? "appendix__bubble appendix__bubble--overlay-active"
              : "appendix__bubble"
          }
          id="appendix__bubble"
        >
          <header>Further Reading</header>
          <div
            className="appendix__bubble__content"
            id="appendix__bubble__content"
          ></div>
        </div>
        <button
          ref={appendixButton}
          className={
            active
              ? "appendix__button appendix__button--active"
              : "appendix__button"
          }
          aria-label={
            active ? "Open Further Reading list" : "Close Further Reading list"
          }
          onClick={toggleOverlay}
          aria-haspopup="true"
          aria-owns="appendix__overlay"
        >
          {active ? <IconClose /> : <IconAppendix />}
        </button>
      </div>
    </>
  )
}

export const AppendixWaypoint = ({ id, page }) => {
  const pageData = AppendixItems.find(obj => {
    return obj.page === page
  })

  const appendixData = pageData.items.find(item => {
    return item.id === id
  })

  return (
    <VisibilitySensor
      onChange={isVisible => {
        if (isVisible) {
          let content = document.getElementById("appendix__bubble__content")
          let bubble = document.getElementById("appendix__bubble")
          bubble.classList.add("appendix__bubble--visible")
          content.innerHTML = `<a href="${appendixData.href}" tabindex="-1">${appendixData.text}</a>`
        } else {
          let bubble = document.getElementById("appendix__bubble")
          bubble.classList.remove("appendix__bubble--visible")
        }
      }}
    >
      <div
        className="appendix__waypoint"
        aria-controls="appendix__bubble"
      ></div>
    </VisibilitySensor>
  )
}
